module.exports = (__webpack_require__(0))(45);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/extends.js from dll-reference element_ui_library
// module id = 18
// module chunks = 5 6 7 8 9